export default __webpack_public_path__ + "fe228ff06ec3979f4361b985e13e18a1.png";